/**
 * Selector reusable de país + ciudad + zona/barrio (opcional).
 * Si el país tiene lista de ciudades, ciudad es dropdown obligatorio.
 * Si el país es "Otro" o no tiene lista, ciudad es texto libre.
 */
import { useEffect } from "react";
import { CITIES_BY_COUNTRY, COUNTRIES, getCitiesFor } from "../data/cities";

interface Props {
  country: string;
  city: string;
  region: string;
  onChange: (next: { country: string; city: string; region: string }) => void;
  /** Si está, el campo zona/barrio se oculta. */
  hideRegion?: boolean;
  /** Disabled mientras se guarda. */
  disabled?: boolean;
}

export function LocationFields({ country, city, region, onChange, hideRegion = false, disabled = false }: Props) {
  const cities = getCitiesFor(country);

  // Si el país cambió y la ciudad actual NO está en la nueva lista, resetear
  useEffect(() => {
    if (cities && city && !cities.includes(city)) {
      onChange({ country, city: "", region });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [country]);

  return (
    <>
      <div className="field">
        <label>País</label>
        <select
          value={country}
          onChange={(e) => onChange({ country: e.target.value, city, region })}
          disabled={disabled}
        >
          {COUNTRIES.map((c) => <option key={c}>{c}</option>)}
        </select>
      </div>

      <div className="field">
        <label>Ciudad</label>
        {cities ? (
          <select
            value={city}
            onChange={(e) => onChange({ country, city: e.target.value, region })}
            disabled={disabled}
          >
            <option value="" disabled>Selecciona tu ciudad…</option>
            {cities.map((c) => <option key={c}>{c}</option>)}
          </select>
        ) : (
          <input
            type="text"
            value={city}
            onChange={(e) => onChange({ country, city: e.target.value, region })}
            placeholder="Ej: Tu ciudad"
            disabled={disabled}
          />
        )}
        {cities && <div className="hint">Si tu ciudad no está, escríbenos a contacto@nilabs.co para agregarla.</div>}
      </div>

      {!hideRegion && (
        <div className="field">
          <label>Zona o barrio (opcional)</label>
          <input
            type="text"
            value={region}
            onChange={(e) => onChange({ country, city, region: e.target.value })}
            placeholder="Ej: Norte, Centro, Chapinero, Laureles…"
            disabled={disabled}
          />
          <div className="hint">Más cercanía → más prioridad en matches y mercado.</div>
        </div>
      )}
    </>
  );
}

/** Lista de países exportada por conveniencia. */
export { COUNTRIES, CITIES_BY_COUNTRY };
